import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/** Nach einem Versand bleibt der Button für diese Anmeldung 30 Minuten gesperrt. */
export const RESEND_MAIL_LOCK_MS = 30 * 60 * 1000;

export interface ResendMailLock {
  /** Zeitpunkt (ms), ab dem wieder gesendet werden darf. */
  until: number;
}

interface ResendMailState {
  /** Sperren pro Anmeldung (team report id). */
  locks: Record<string, ResendMailLock>;
}

interface ResendMailActions {
  markSent: (registrationId: number) => void;
}

type ResendMailStore = ResendMailState & ResendMailActions;

const withoutExpired = (
  locks: Record<string, ResendMailLock>,
): Record<string, ResendMailLock> =>
  Object.fromEntries(
    Object.entries(locks).filter(
      ([, lock]) => Number.isFinite(lock?.until) && lock.until > Date.now(),
    ),
  );

/**
 * Merkt sich, für welche Anmeldung die Quittung gerade erneut verschickt wurde,
 * damit derselbe Club nicht mehrfach hintereinander angeschrieben wird. Die
 * Sperre übersteht das Schliessen des Dialogs und einen Reload; abgelaufene
 * Sperren werden beim nächsten Versand aufgeräumt.
 */
export const useResendMailStore = create<ResendMailStore>()(
  persist(
    (set) => ({
      locks: {},

      markSent: (registrationId) =>
        set((state) => ({
          locks: {
            ...withoutExpired(state.locks),
            [String(registrationId)]: {
              until: Date.now() + RESEND_MAIL_LOCK_MS,
            },
          },
        })),
    }),
    {
      name: 'store-resend-mail',
    },
  ),
);
